import Button from '@material-ui/core/Button';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import Footer from '~/components/Footer';
import { ApplicationState, store } from '~/store';
import { multipleLanguageRequest } from '~/store/ducks/language/actions';
import { setThemeRequest } from '~/store/ducks/theme/actions';
import { Container, Content, Header } from './styles';

interface StateProps {
  user: any;
  language: any;
}

interface DispatchProps {
  multipleLanguageRequest(language: string): void;
  setThemeRequest(): void;
}

type Props = StateProps & DispatchProps;

class PoliticaPrivacidade extends Component<Props> {
  state = {};

  componentDidMount() {
    const { multipleLanguageRequest } = this.props;
    multipleLanguageRequest('ptbr');

    document.title = 'Fazer logon';
  }

  render() {
    const { signed } = store.getState().auth;

    return (
      <Container>
        <Header>
          <div className="content-header-policy">
            <div className="logo">Vrio</div>
            <div className="login">
              {signed ? (
                <a href="/home">
                  <Button>Voltar ao menu principal</Button>
                </a>
              ) : (
                <a href="/">
                  <Button>Fazer login</Button>
                </a>
              )}
            </div>
          </div>
        </Header>
        <Content>
          <div className="content-header">
            <h1>POLÍTICA DE PRIVACIDADE</h1>
            <h4>(“Política”)</h4>
          </div>

          <div className="policy-question-fix">
            <p>
              A sua privacidade é muito importante para a SKY. Dessa forma,
              desenvolvemos uma Política de Privacidade que dispõe sobre a
              maneira como nós tratamos e protegemos os seus dados pessoais.
              Gostaríamos de fornecer as informações necessárias para que você
              tome as suas próprias decisões a respeito de sua privacidade e,
              também, sobre como você poderá navegar em nossos sites e
              aplicativos.
            </p>

            <p>
              A presente Política de Privacidade é adicional e deve ser
              interpretada conjuntamente com os demais documentos que dispõem
              sobre as condições da prestação do serviço de telecomunicação do
              qual você é usuário, inclusive o contrato de prestação de serviços
              celebrado entre você e a SKY. Na mesma linha, a presente Política
              de Privacidade deve ser sempre lida e interpretada em conformidade
              com a legislação em vigor, em especial aquela que trata da
              proteção de dados pessoais.
            </p>

            <p>
              Esclarecemos, também, que as informações dispostas nesta Política
              são aplicáveis apenas aos serviços e plataformas, digitais ou não,
              ofertados, controlados ou gerenciadas pelo grupo SKY. Portanto,
              não podemos nos responsabilizar por serviços quanto aos quais a
              SKY não possui controle ou ingerência.
            </p>

            <h3>1. Conceitos e Definições</h3>

            <p>
              Para os fins desta Política, os seguintes conceitos e definições
              devem ser considerados:
            </p>

            <p>
              “COOKIES”: arquivos de computador em formato de texto que
              armazenam e reconhecem dados de navegação, com a finalidade de
              melhor conhecer os hábitos de navegações dos usuários, garantir o
              correto funcionamento dos serviços e proporcionar uma melhor
              experiência aos usuários.
            </p>

            <p>
              “DADOS OU INFORMAÇÕES PESSOAIS”: toda informação ou conjunto de
              informações relacionada(s) a uma pessoa natural identificada ou
              identificável, podendo incluir, por exemplo, nome e sobrenome,
              endereço, número do telefone, e-mail, número do cartão de crédito,
              número do documento de identidade ou do cadastro de pessoas
              físicas.
            </p>

            <p>
              “PLATAFORMAS”: quaisquer páginas, aplicativos, canais e/ou meios
              de interação disponibilizados e gerenciados pela SKY, digitalmente
              ou não.
            </p>

            <p>
              “TRATAMENTO”: qualquer operação com dados pessoais realizada pela
              SKY, por meio analógico ou digital, como as que se referem à
              coleta, produção, recepção, classificação, utilização, acesso,
              reprodução, transmissão, distribuição, processamento,
              arquivamento, armazenamento, eliminação, avaliação ou controle da
              informação, modificação, comunicação, transferência, difusão ou
              extração.
            </p>

            <p>
              “SERVIÇOS”: quaisquer aplicativos, sites, produtos, serviços de
              valor adicionado, serviços de telecomunicações, tecnologias e
              demais facilidades oferecidas pela SKY que envolvam tratamento de
              dados pessoais.
            </p>

            <p>
              “VOCÊ”: você, cliente SKY e/ou usuário de qualquer das plataformas
              ou serviços disponibilizados pela SKY.
            </p>

            <h3>2. Informações Coletadas</h3>

            <p>
              Para viabilizar a regular execução dos contratos de prestação dos
              serviços providos pela SKY, será necessário o tratamento de alguns
              dados pessoais tais como, mas não limitados a nome, endereço,
              telefone, e-mail, informações bancárias, entre outros. O
              fornecimento desses dados pessoais também é necessário para o
              correto funcionamento dos serviços e plataformas SKY, sendo certo
              que o não compartilhamento de tais dados pessoais com a SKY pode
              inviabilizar o início ou a continuidade dos serviços oferecidos
              pela SKY ou o correto funcionamento das plataformas SKY.
            </p>

            <p>
              Geralmente, os dados pessoais tratados pela SKY são solicitados em
              sua primeira interação em nossas plataformas digitais, como, por
              exemplo, quando você deseja se cadastrar em nossas plataformas
              digitais. Ao preencher os cadastros relacionados aos serviços ou
              plataformas da SKY e ao usar as plataformas e/ou serviços da SKY,
              você declara ter lido, de forma atenta, todas as condições desta
              Política, manifestando de forma livre, informada e inequívoca seu
              desejo de continuar a navegação e o uso dos referidos serviços, e
              estando ciente de que, para tanto, a SKY tratará seus dados
              pessoais, para fins de cumprimento das obrigações previstas nos
              contratos de prestação de serviços em que você é parte ou na
              legislação em vigor, para garantir a sua segurança nos processos
              de identificação e autenticação nas plataformas SKY, e/ou para
              possibilitar o exercício de legítimos interesses da SKY, ou,
              ainda, para outros fins, quanto aos quais será solicitado seu
              consentimento, na forma da Lei.. Em nossas plataformas digitais,
              nós também utilizamos as informações coletadas, seja via
              preenchimento ou conclusão do cadastro, com base no seu
              consentimento, quando aplicável, ou no legítimo interesse de
              fornecer e aprimorar a qualidade de nossos serviços de
              entretenimento, comunicar ofertas especiais e benefícios, além de
              facilitar, customizar e melhorar a sua navegação nestas
              plataformas; ou, ainda, caso você já seja um cliente SKY, no
              contexto da execução do(s) contrato(s) de prestação de serviços.
            </p>

            <p>
              Quando você utiliza os serviços e plataformas oferecidos pelo
              grupo SKY para fazer compras, por exemplo, algumas informações
              sobre a transação e/ou dados associados a ela podem ser coletadas,
              tais como o valor pago e o meio de pagamento utilizado. Essas
              informações são tratadas pela SKY principalmente para viabilizar o
              processamento e envio de avisos de transações, o gerenciamento de
              riscos e/ou o fornecimento de proteção ao crédito e implementação
              de medidas antifraude.
            </p>

            <p>
              Certas informações também podem ser coletadas quando você entra em
              contato com a SKY, seja através do Serviço de Atendimento ao
              Consumidor (SAC) ou qualquer outro canal de atendimento, sempre no
              contexto da prestação dos serviços por você contratados, do
              cumprimento de obrigações legais ou em situações em que a SKY
              possui o legítimo interesse de melhorar as suas plataformas e/ou
              serviços fornecidos, de acordo com as previsões legais aplicáveis.
            </p>

            <p>
              Com o objetivo de realizar auditorias internas, de garantir
              proteção ao crédito, implementar medidas antifraude ou assegurar o
              cumprimento da legislação em vigor, a SKY também pode
              eventualmente tratar dados pessoais disponibilizados por
              terceiros, desde que legitimamente obtidos, a exemplo de
              provedores de dados e agências de crédito, e/ou disponibilizados
              de forma pública.
            </p>

            <p>
              Resumindo, a SKY apenas tratará seus dados pessoais nas hipóteses
              previstas nesta Política; para cumprimento de obrigações
              contratuais em que você é parte; por força de ordem judicial;
              mediante seu consentimento manifestado de forma livre, informada e
              inequívoca, quando necessário; ou nas demais hipóteses autorizadas
              por Lei.
            </p>

            <p>
              A SKY não é responsável pela qualidade das informações pessoais
              fornecidas por você e confiamos que todas elas sejam verdadeiras,
              completas e não enganosas. Em nenhuma hipótese a SKY será
              responsabilizada pelo mau uso, por você ou por terceiros, dos
              serviços e das plataformas ofertadas e por referidas informações
              incorretas ou desatualizadas.
            </p>

            <h3>3.Compartilhamento de Informações</h3>

            <p>
              A SKY está sempre buscando proporcionar privacidade aos nossos
              clientes e usuários, portanto, temos como política institucional o
              não compartilhamento de dados pessoais com terceiros não
              integrantes do grupo SKY. Fazem parte do grupo SKY suas empresas
              controladoras, coligadas e subsidiárias.
            </p>

            <p>
              Todavia, para que possamos oferecer nossos serviços e plataformas,
              determinados dados pessoais poderão ser compartilhados com
              terceiros não relacionados, sempre respeitando a legislação
              brasileira em matéria de proteção de dados pessoais. Esse
              compartilhamento, quando necessário, ocorrerá para finalidades
              específicas e determinadas, sempre objetivando o correto
              funcionamento das plataformas e serviços que a SKY disponibiliza a
              você. Ao utilizar nossas plataformas ou serviços, você manifesta
              seu desejo de continuar com a navegação ou o uso de referidos
              serviços, estando ciente de que seus dados pessoais poderão ser
              compartilhados com terceiros não relacionados, sendo certo que a
              SKY realizará tal compartilhamento para fins da execução de
              obrigações contratuais ou legais; para possibilitar o exercício de
              um legítimo interesse; e/ou mediante o seu consentimento, quando
              aplicável, na forma da Lei.
            </p>

            <p>
              A SKY poderá compartilhar dados pessoais com empresas parceiras
              e/ou fornecedores de serviços que trabalham com a SKY ou que atuam
              em nome da SKY, e que estejam vinculados à prestadora por meio de
              acordos de confidencialidade e/ou privacidade. Estes terceiros
              poderão tratar seus dados pessoais para auxiliar a SKY na
              prestação dos serviços, no cumprimento das obrigações
              estabelecidas em nossos contratos, na manutenção e aprimoramento
              de nossas plataformas e/ou na nossa comunicação com você e com
              nossos demais clientes ou parceiros de mercado.
            </p>

            <p>
              Para cumprimento de obrigações legais e/ou regulatórias aplicáveis
              à SKY, determinados dados pessoais também podem ser compartilhados
              com e/ou transferidos às autoridades competentes, tais como, mas
              não se limitando, ao Banco Central do Brasil – BCB, ao Conselho de
              Controle de Atividades Financeiras – COAF, à Receita Federal do
              Brasil, a Birôs de Crédito e às Secretarias Estaduais e Municipais
              da Fazenda ou quaisquer outras agências, departamentos,
              instituições ou entidades públicas para quais o envio de referidos
              dados pessoais seja um obrigação.
            </p>

            <p>
              Além disso, como de praxe no mercado, a SKY pode armazenar seus
              dados pessoais em sistema de “nuvem” ou infraestruturas e
              tecnologias similares, cujos servidores geralmente ficam
              localizados em diversos países, tais como os Estados Unidos da
              América. No tratamento de dados pessoais que envolve fluxo
              transfronteiriço de informações a SKY adota salvaguardas técnicas
              e contratuais para garantir que você possa exercer todos os
              direitos assegurados em Lei. Ao utilizar os serviços e/ou as
              plataformas da SKY, você manifesta seu desejo de continuar a
              navegação e o uso dos referidos serviços, mesmo ciente de que seus
              dados poderão ser tratados no exterior, nos termos desta Política
              e nos limites da legislação aplicável, reconhecendo que sem a
              referida transferência internacional a prestação dos nossos
              serviços pode ser tornar inviável.
            </p>

            <h3>4. Promoções Comerciais</h3>

            <p>
              Periodicamente, podemos oferecer promoções e ofertas comerciais
              que o beneficie por meio de nossas plataformas digitais ou
              quaisquer outros meios de comunicação, com base em nosso interesse
              de promover, indicar e/ou fornecer informações sobre nossos
              serviços, sempre nos limites estabelecidos na legislação
              aplicável. Ao utilizar nossas plataformas ou serviços você
              concorda em ser contatado sobre referidas promoções e ofertas., A
              qualquer momento, você poderá manifestar seu desinteresse pelo
              recebimento de tais comunicações através do e-mail indicado ao
              final desta Política ou do site{' '}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.sky.com.br/"
              >
                www.sky.com.br
              </a>
              . Eventualmente, para você participar de promoções ou ofertas
              referentes aos produtos e serviços SKY e/ou para que possamos
              entrar em contato com você, será necessário o fornecimento de suas
              informações pessoais de identificação, como seu nome, endereço,
              e/ou e-mail.
            </p>

            <p>
              Pedimos, também, que revise com atenção as regras das promoções,
              concursos e/ou ofertas. Elas podem conter informações importantes
              sobre como nós e nossos patrocinadores utilizam as suas
              informações pessoais.
            </p>

            <h3>5. ‘Cookies’</h3>

            <p>
              Para fazer com que nossas plataformas digitais atendam melhor às
              suas necessidades, no contexto do legítimo interesse da SKY, você
              declara ter ciência de que nós utilizamos um recurso padrão
              encontrado em seu navegador de Internet, chamado 'cookie', para
              individualizar a navegação de cada usuário. Por conta disso, um
              número de identificação anônimo e aleatório fica registrado em seu
              computador.
            </p>

            <p>
              Os 'cookies' identificam apenas o computador usado para acessar as
              nossas plataformas digitais. Utilizamos 'cookies' para relembrar
              informações pessoais quando você utiliza nossas plataformas
              digitais, para acompanhar o andamento de promoções e concursos,
              bem como para facilitar e agilizar o preenchimento de formulários.
              A nossa meta nestes casos é fazer com que a sua experiência com a
              SKY seja mais conveniente e pessoal.
            </p>

            <p>
              Para navegar sem a utilização de 'cookies' você pode configurar o
              seu browser para rejeitar todos os “cookies”, ou você pode
              configurar o seu computador para lhe informar quando um 'cookie' é
              baixado.
            </p>

            <h3>6. Empresas Parceiras e Marketing</h3>

            <p>
              A SKY pode enviar e-mails para o seu endereço eletrônico,
              mensagens para seu celular e/ou decodificador, ou ainda realizar
              ligações contendo ofertas e/ou informações sobre produtos e
              serviços da SKY e de empresas parceiras, sendo certo que no
              momento de seu cadastro em nossas plataformas digitais e no
              momento de sua assinatura dos serviços ou aquisição dos produtos
              SKY, você declara ter ciência de que poderá receber tais
              comunicações. O usuário que não tiver mais interesse em receber
              tais correspondências poderá, a qualquer momento, informar a SKY e
              solicitar o cancelamento do envio de tais comunicações através do
              e-mail indicado ao final desta Política ou do site{' '}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.sky.com.br/"
              >
                www.sky.com.br
              </a>
              .
            </p>

            <h3>7. Segurança da Informação</h3>

            <p>
              Para preservar a confidencialidade dos seus dados pessoais, a SKY
              mantém medidas atualizadas de segurança técnicas, físicas e
              administrativas projetadas especialmente para o fornecimento de
              proteção necessária contra perda, divulgação, alteração e
              quaisquer outras violações aos seus dados pessoais. Dentre essas
              medidas, incluem-se o controle e rastreamento de acessos de
              usuários, proteções de softwares (como antivírus e firewalls) e o
              backup dos dados.
            </p>

            <p>
              Infelizmente, por mais que o nosso sistema seja seguro, é de
              notório conhecimento no meio tecnológico que nenhum sistema de
              segurança é completamente impenetrável. Sendo assim, não temos
              como garantir segurança absoluta de nosso banco de dados e nem
              podemos garantir que as informações pessoais de identificação que
              você forneceu não possam ser interceptadas quando a transmissão é
              feita pela Internet.
            </p>

            <p>
              Você pode nos ajudar a cuidar de sua segurança on-line evitando
              acessar sites suspeitos e baixar arquivos de origem desconhecida,
              mantendo seu sistema operacional sempre atualizado, utilizando
              programas de segurança (antivírus e firewall, por exemplo) e
              escolhendo senhas complexas e não as fornecendo para terceiros. A
              SKY nunca solicitará que você revele sua senha. Se receber
              qualquer mensagem nesse sentido, por favor a ignore e informe
              imediatamente à SKY através do e-mail indicado ao final desta
              Política. Se, por qualquer motivo, tiver fornecido sua senha a
              terceiros ou suspeite que terceiros possam ter acesso a ela ou
              note movimentações estranhas relacionadas ao seu uso dos serviços,
              produtos ou plataformas SKY, pedimos que a altere imediatamente.
            </p>

            <h3>8. Direito dos Usuários</h3>

            <p>
              A SKY se preocupa com sua a privacidade e, por conta disso, está
              comprometida com a proteção de todos os seus direitos dispostos
              nas legislações sobre privacidade e proteção de dados em vigor.
              Você possui a faculdade de exercer, por exemplo, os direitos de
              acesso, de retificação, de anonimização, de bloqueio ou de
              eliminação de seus dados pessoais, bem como de solicitar
              informação sobre as entidades públicas e privadas com as quais a
              SKY compartilhou seus dados e/ou a revogação de eventual
              consentimento fornecido anteriormente e suas consequências, quando
              assim aplicável.
            </p>

            <p>
              Para exercer estes e outros direitos previstos na legislação
              vigente sobre privacidade e proteção de dados pessoais, pedimos
              que encaminhe sua solicitação através do e-mail indicado ao final
              desta Política ou que acesse o link de acesso ao portal LGPD
              disponível no site{' '}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.sky.com.br/"
              >
                www.sky.com.br
              </a>
              .
            </p>

            <h3>9. Mudanças em Nossa Política de Privacidade</h3>

            <p>
              A SKY está comprometida com a proteção de sua privacidade e
              pretende estar sempre em dia nos assuntos relacionados à proteção
              de dados pessoais em conformidade com a legislação brasileira
              aplicável. Nesse sentido, a SKY poderá atualizar e/ou alterar sua
              Política de tempos em tempos, observando, sempre que necessário,
              os deveres de publicidade que constam da legislação em vigor.
            </p>

            <p>
              Consulte essa página regularmente para estar atualizado acerca das
              medidas de privacidade e proteção de dados utilizadas pela SKY.
            </p>

            <h3>10. Direitos Autorais e Propriedade Intelectual</h3>

            <p>
              Todos os textos, imagens, sons e aplicativos exibidos em nossas
              plataformas digitais, bem como os materiais promocionais,
              publicitários ou de comunicação são protegidos por direitos
              autorais, não sendo permitido modificá-los, reproduzi-los,
              armazená-los, transmiti-los, copiá-los, distribuí-los por qualquer
              que seja a forma, para fins comerciais, sem o prévio e formal
              consentimento da SKY.
            </p>

            <h3>11. Questões</h3>

            <p>
              Se você tiver questionamentos ou dúvidas em relação a esta
              Política, ao tratamento de dados realizado pela SKY ou ao
              exercício de seus direitos relacionados a dados pessoais, por
              favor, entre em contato conosco através do atendimento@sky.com.br.
            </p>
          </div>
          <Footer />
        </Content>
      </Container>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  user: state.user.profile,
  language: state.language.data,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  ...bindActionCreators({ multipleLanguageRequest, setThemeRequest }, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PoliticaPrivacidade);
